import * as React from 'react';
import Box from '@mui/material/Box';
import FormControlSelect from '../FormControl/Index';
import ReplayIcon from '@mui/icons-material/Replay';
import "../CalendarFilters/Style.css";
import DoneIcon from '@mui/icons-material/Done';
import Filtericon from "../../Assets/Filtericon.svg";
import Filter from "../../Assets/FilterOval.svg";
export default function CalendarFilters({ events, downloadExcel, selectedFilters, setSelectedFilters, handleApplyFilter, handleClearFilters, commingFilters, setComingFilters }) {
    const handleSelectChange = (key, value) => {
        setSelectedFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const location = window?.location?.pathname;
    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        gap: 2,
                    }}
                >
                    <div className='main-for-filters'>
                        <div className="AILeads-Filter1st">
                            <div>
                                <div className="AiLeads-filter-icons">
                                    <img src={Filter} alt="" />
                                </div>
                                <div>
                                    <img src={Filtericon} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='year-select-main'>
                            <FormControlSelect
                                value={selectedFilters?.years}
                                handleChange={(value) => handleSelectChange('years', value)}
                                dataList={commingFilters?.years.sort((a, b) => b - a) || []}
                                placeholder="Select Year"
                            />
                        </div>
                        <div className='year-select-main'>
                            <FormControlSelect
                                value={selectedFilters?.months}
                                handleChange={(value) => handleSelectChange('months', value)}
                                dataList={commingFilters?.months || []}
                                placeholder="Month"
                            /></div>
                        <div className='year-select-main'><FormControlSelect
                            value={selectedFilters?.teamList}
                            handleChange={(value) => handleSelectChange('teamList', value)}
                            dataList={commingFilters?.teamList || []}
                            placeholder="JO Teams"
                        /></div>
                        <div className='year-select-main'><FormControlSelect
                            value={selectedFilters?.associateList}
                            handleChange={(value) => handleSelectChange('associateList', value)}
                            dataList={commingFilters?.associateList.sort((a, b) => {
                                const lastNameA = a?.split(" ")?.slice(-1)[0];
                                const lastNameB = b?.split(" ")?.slice(-1)[0];
                                return lastNameA.localeCompare(lastNameB);
                            }) || []}
                            placeholder="JO Associate"
                        /></div>

                        <div className='year-select-main'><FormControlSelect
                            value={selectedFilters?.categoriesList}
                            handleChange={(value) => handleSelectChange('categoriesList', value)}
                            dataList={commingFilters?.categoriesList.sort() || []}
                            placeholder="Category"
                        /></div>
                    </div>
                    <div className='main-for-btns'>
                        <button onClick={handleApplyFilter}
                            className="apply-btn-calender"
                        >
                            <DoneIcon className="apply-icon-cal" /> Apply
                        </button>
                        <button
                            className="clear-btn-calender"
                            onClick={handleClearFilters}
                        >
                            <ReplayIcon className="clear-icon-cal" /> Reset
                        </button>
                    </div>
                </Box>
                {
                    location === "/listView" ? <div className='download-to-excel'>
                        <button onClick={() => downloadExcel(events)} >Download To Excel</button>
                    </div> : null
                }
            </Box>
        </>
    );
}
